// PanelBookDialog.tsx — Generate a PDF panel book for all panels in the project

import DialogBase from './DialogBase';
import { useStore } from '../store/useStore';
import { buildPanelBookBytes, panelBookFilename } from '../utils/pdfExport';
import { gatedDownload } from '../utils/exportGateway';
import { useEntitlement } from '../auth/AuthProvider';

export default function PanelBookDialog() {
  const project = useStore(s => s.project);
  const { refresh } = useEntitlement();

  async function handleExport() {
    if (!project) return;
    const res = await gatedDownload({
      artifact: 'pdf',
      filename: panelBookFilename(project),
      mimeType: 'application/pdf',
      preflight: () => {
        const hasValidPanel = project.panels.some(p => {
          const { width, height } = p.mpvar;
          return width && height && width > 0 && height > 0;
        });
        if (!hasValidPanel) {
          throw new Error('No valid panels to export (check panel dimensions).');
        }
      },
      build: () => {
        const bytes = buildPanelBookBytes(project);
        if (!bytes) throw new Error('No valid panels to export (check panel dimensions).');
        return bytes;
      },
    });
    if (res.ok) {
      refresh();
    } else if (res.reason === 'preflight') {
      alert(res.message ?? 'Cannot export panel book.');
    } else if (res.reason === 'producer_error') {
      alert(res.message ?? 'PDF export failed.');
    } else if (res.reason === 'network') {
      alert(`Export failed: ${res.message ?? 'network error'}`);
    }
    // no_tokens / unauthorized handled by upsell modal
  }

  return (
    <DialogBase
      title="Export Panel Book PDF"
      okLabel="Generate PDF"
      onOk={() => { void handleExport(); }}
    >
      {project ? (
        <>
          <p className="dialog-info">
            Project: <strong>{project.name}</strong>
          </p>
          <p className="dialog-info">
            {project.panels.length} panel{project.panels.length !== 1 ? 's' : ''} will be included.
          </p>
          <p className="dialog-info">
            Each panel gets a full-page summary with dimensions, openings, and material schedule.
          </p>
          <p className="dialog-info">
            <em>Costs 1 token.</em>
          </p>
        </>
      ) : (
        <p className="dialog-warning">No project open.</p>
      )}
    </DialogBase>
  );
}
